import lexifyCursive from './logo-lexify-grey.png';
import logo from './green-checkmark-animated.gif';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={lexifyCursive} alt="Lexify" />
        <h4 style={{ color: 'slategrey' }}>EHR Launch<br/>SMART on FHIR</h4>
        <img src={logo} className="App-logo" alt="logo" />
      </header>
    </div>
  );
}

export default App;